type Props = {
  onReload: () => void;
  onDismiss: () => void;
};

/** Banner nhỏ khi service worker có bản mới đã sẵn sàng — không tự reload, chờ người dùng bấm. */
export default function UpdateBanner({ onReload, onDismiss }: Props) {
  return (
    <div className="update-banner" role="status">
      <span>Có bản mới, tải lại nhé.</span>
      <div className="update-banner-actions">
        <button type="button" className="update-banner-btn" onClick={onReload}>
          Tải lại
        </button>
        <button type="button" className="update-banner-dismiss" onClick={onDismiss} aria-label="Đóng">
          ✕
        </button>
      </div>
    </div>
  );
}
